'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionsChecklistPreview', ['$scope', '$stateParams', 'FBResponses', 'IPTemplates', 'IPChecklists',
        function ($scope, $stateParams, FBResponses, IPTemplates, IPChecklists) {
            $scope.resetChecklist();
            $scope.form = $stateParams.form;
            $scope.formID = $stateParams.formID;
            $scope.loading = true;
            $scope.deficiencyScore = { score: 0 };
            $scope.deficiencies = {
                fail: 0,
                pass: 0,
                ignore: 0
            }
            $scope.passingChecklist = $scope.$parent.checklist;
            $scope.passingChecklist.preview = true;

            if ($scope.checklist.require_responsible_party_signoff === true && ($scope.checklist.signature_type_in_person === null || $scope.checklist.signature_type_in_person === undefined)) {
                $scope.checklist.signature_type_in_person = true;
            }

            $scope.clearSignature = function () {
                if ($scope.checklist.signature_type_in_person == false) {
                    $scope.signature_first_name = null;
                    $scope.signature_last_name = null;
                    $scope.signature_certification_number = null;
                    $scope.signature = null;
                }
            }

            if ($stateParams.formID != null) {
                FBResponses.getByID(guid(), $stateParams.formID).then(function (response) {
                    if (response != null) {
                        var form = response.form;
                        if (form.pages.length > 0) {
                            form.pages[0].tab_active = true;
                        }
                        $scope.form = form;

                        // Don't generate blank inspection document if one exists && checklist must be published
                        if (!$scope.$parent.pdfGenerated && $scope.$parent.checklist.published) {
                            var cleanName = $scope.$parent.checklist.name.replace(/[\/:*?"<>|']/g, '');
                            var inspection = {
                                id: '00000000-0000-0000-0000-000000000000',
                                number: cleanName,
                                outcome: null,
                                checklist: {
                                    template: $scope.$parent.checklist,
                                    deficiencies_fail: 0,
                                    response: {
                                        form: form
                                    },
                                }
                            };

                            IPChecklists.generatingPDF(inspection).then(function (documentData) {
                                // Set data for gutter
                                if (documentData) {
                                    $scope.$parent.documentInfo = {
                                        id: documentData.id,
                                        code: documentData.code
                                    };
                                    $scope.$parent.pdfGenerated = true;
                                    $scope.showGenerate = false;
                                    IPTemplates.saveDocumentData($scope.$parent.checklist.id, documentData.id, documentData.code).then(function (doc) {

                                    });
                                }
                            });
                        }
                    }
                    $scope.loading = false;
                })
            }

            $scope.complete = function () {
                return $scope.deficiencies.fail + $scope.deficiencies.pass + $scope.deficiencies.ignore == $scope.checklist.deficiencies_total;
            }

            $scope.failed = function () {
                if ($scope.checklist.passing_score_type) {
                    return $scope.checklist.passing_score > $scope.deficiencyScore.score;
                }
                else {
                    return $scope.deficiencies.fail >= $scope.checklist.auto_fail;
                }
            }

            $scope.resize = function () {
                if (document != null && document.querySelector != null) {
                    var canvas = document.querySelector("canvas");

                    if (canvas != null && canvas.offsetWidth != null && canvas.offsetHeight != null && canvas.getContext != null) {
                        var ratio = Math.max(window.devicePixelRatio || 1, 1);
                        canvas.width = canvas.offsetWidth * ratio;
                        canvas.height = canvas.offsetHeight * ratio;
                        canvas.getContext("2d").scale(ratio, ratio);
                    }
                }
            }
        }])
    ;